import { IIndividualTypeColor } from "features/individuals/individuals/individuals-list-table/types";

export const COLORS = ["#009642", "#F49D1B", "#004300", "#656565", "#A432B1"];
const INDEX_OFFSET = 1;
export const COLORS_MAX_LENGTH_INDEX = COLORS.length - INDEX_OFFSET;
export const IndividualTypeColorMap: Record<string, IIndividualTypeColor> = {
  0: {
    color: "#344054",
    bg: "#F2F4F7",
  },
  1: {
    color: "#344054",
    bg: "#F2F4F7",
  },
  2: {
    color: "#344054",
    bg: "#F2F4F7",
  },
  3: {
    color: "#175CD3",
    bg: "#EFF8FF",
  },
};
